import "../scss/main.scss";

(function ($) {
    $(document).ready(function () {
        theme.init();
    });

    var theme = {
        init: function () {
            this.headerFunctions();
            this.initSliders();
            this.animations();
            this.faq();
            this.modal();
            this.ajaxTherapists();
            this.ameliaOrder();
            this.favorites();
            this.form();
            this.siteFunctions();

            if ($("body").hasClass("page-template-page-testimonials")) {
                this.testimonials();
            }

            function countChildrenWithClass(containerId, className) {
                var count = $(containerId).children("." + className).length;
                if (count == 0) {
                    $(containerId).parent().find(".count").hide();
                } else {
                    $(containerId).parent().find(".count").show();
                    $(containerId).parent().find(".count").html(count);
                }
            }

            countChildrenWithClass("#therapists .checkbox-group", "active");
        },

        headerFunctions: function () {
            // mobile menu toggle
            $(".toggle-nav").click(function (e) {
                e.preventDefault();
                $(".icon-bar").toggleClass("toggled");
                $(".main-menu-container").toggleClass("opened");
                $("body").toggleClass("fixed");
                $(".account-menu, .my-account").removeClass("opened");
            });

            // sticky header
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();

                if (scroll >= 300) $("header.navbar").addClass("fixed");
                else $("header.navbar").removeClass("fixed");
            });

            // acount link {
            if ($(window).width() < 768) {
                $(".my-account").click(function (e) {
                    e.preventDefault();
                    $(this).toggleClass("opened");
                    $("body").toggleClass("fixed");
                    $(".account-menu").toggleClass("opened");
                    $(".main-menu-container").removeClass("opened");
                    $(".icon-bar").removeClass("toggled");
                });
            }
        },

        initSliders: function () {
            $("#our-team .slider").slick({
                arrows: false,
                autoplay: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: false,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: false,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                            dots: true,
                        },
                    },
                ],
            });

            $("#testimonials .slider").slick({
                prevArrow: "<span class='slick-arrow slick-prev'></span>",
                nextArrow: "<span class='slick-arrow slick-next'></span>",
                autoplay: true,
                autoplaySpeed: 4000,
                fade: true,
            });

            $("#testimonials-grid .slider").slick({
                prevArrow: "<span class='slick-arrow slick-prev'></span>",
                nextArrow: "<span class='slick-arrow slick-next'></span>",
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            $("ul.testimonials-list").slick({
                prevArrow: "<span class='slick-arrow slick-prev'></span>",
                nextArrow: "<span class='slick-arrow slick-next'></span>",
                slidesToShow: 2,
                autoplay: true,
                autoplaySpeed: 4000,
                dots: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            if ($(window).width() < 768) {
                $("#features .boxes").slick({
                    arrows: false,
                    autoplay: false,
                    centerMode: true,
                });
            }

            if ($(window).width() < 1080) {
                $("#booking-info:not(.about-features) .container, #booking-info.about-features .flexed").slick({
                    autoplay: false,
                    prevArrow: "<span class='slick-arrow slick-prev'></span>",
                    nextArrow: "<span class='slick-arrow slick-next'></span>",
                });
            }
        },

        animations: function () {
            //smooth scroll
            $(
                'a[href^="#"]:not(#load-more):not(.toggle-btn):not(.show-more-terms):not(.add-to-favorites):not(.reset):not(.show-more-blurbs):not(.open-popup):not(.modal-link):not(.close)'
            ).click(function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                $("html, body").animate(
                    {
                        scrollTop: $(href).offset().top - 100,
                    },
                    800
                );
            });

            // on viewport animations
            // function isInViewport(node) {
            //   var rect = node.getBoundingClientRect();
            //   return (
            //     (rect.height > 0 || rect.width > 0) &&
            //     rect.bottom >= 0 &&
            //     rect.right >= 0 &&
            //     rect.top <=
            //       (window.innerHeight || document.documentElement.clientHeight) &&
            //     rect.left <=
            //       (window.innerWidth || document.documentElement.clientWidth)
            //   );
            // }

            // $(window).scroll(function () {
            //   $(".viewport-animated").each(function () {
            //     if (isInViewport(this)) {
            //       $(this).addClass("inViewport");
            //     }
            //   });
            // });

            // hero animations

            if ($(window).width() > 768 && $("body").hasClass("home")) {
                var element = $("#hero .hero-image .shapes");
                var windowHeight = $(window).height();

                $(window).scroll(function () {
                    var scrollTop = $(this).scrollTop();
                    var elementOffset = element.offset().top + 150;
                    var distanceFromTop = elementOffset - scrollTop;
                    var progress = 1 - Math.max(0, Math.min(1, distanceFromTop / windowHeight));
                    var rotateAngle = Math.min(progress * 15, 15);

                    if (scrollTop < 80) {
                        element.css("transform", "rotate(0deg)");
                    } else {
                        element.css("transform", "rotate(" + rotateAngle + "deg)");
                    }
                });
            }
        },

        faq: function () {
            $(".faq-toggles .faq-item .title").click(function (e) {
                e.preventDefault();
            });

            $(".faq-toggles .faq-item.closed").on("click", function () {
                $(this).toggleClass(["closed", "opened"]);
            });
        },

        siteFunctions: function () {
            // login page form change
            $("a.toggle-btn").on("click", function (e) {
                e.preventDefault();
                $("#register-wrap, #login-wrap").toggle();
            });

            // register successful
            // $("form.register").submit(function () {
            //   var form = $(this);
            //   $.ajax({
            //     type: form.attr("method"),
            //     url: form.attr("action"),
            //     data: form.serialize(),
            //     success: function (data) {
            //       $("#custom-login").addClass("confirmation");
            //       $(
            //         "#custom-login .image, #custom-login .form-box, #custom-login .breadcrumbs"
            //       ).hide();
            //       $("#thank-you").fadeIn();
            //     },
            //     error: function (data) {},
            //   });
            //   return false;
            // });

            $("#goto-register").on("click", function (e) {
                e.preventDefault();
                $("#thank-you, #login-wrap").hide();
                $("#custom-login").removeClass("confirmation");
                $("#custom-login .image, #custom-login .form-box, #custom-login .breadcrumbs, #register-wrap").fadeIn();
            });

            $("#goto-login").on("click", function (e) {
                e.preventDefault();
                $("#thank-you, #register-wrap").hide();
                $("#custom-login").removeClass("confirmation");
                $("#custom-login .image, #custom-login .form-box, #custom-login .breadcrumbs, #login-wrap").fadeIn();
            });

            // therapist testimonial toggle

            $(document).on("click", "#show-more", function (e) {
                e.preventDefault();
                $('.testimonials-list li[style="display: none;"]').fadeIn();
                console.log("elo");
                $(this).hide();
            });

            // therapists loop tags

            $(document).on("click", ".show-more-terms", function (e) {
                e.preventDefault();
                $(this).parent().parent().find(".hidden-term").removeClass("hidden-term");
                $(this).parent().hide();
            });

            $(document).on("click", ".show-more-blurbs", function () {
                $(this).parent().find(".additional").toggleClass("hidden");
                $(this).find(".show").toggle();
                $(this).find(".hide").toggle();
            });
        },

        modal: function () {
            var scrollPosition;
            $(".modal-link").on("click", function (e) {
                e.preventDefault();
                scrollPosition = window.pageYOffset;
                $("#modal").addClass("opened");
                $("body")
                    .addClass("fixed")
                    .css({
                        top: -scrollPosition - 72,
                    });
                $("#modal .video").get(0).play();
            });

            $(document).on("click", ".loop-link", function (e) {
                e.preventDefault();
                scrollPosition = window.pageYOffset;
                var videoSrc = $(this).attr("videoSrc");

                $("#modal video source").attr("src", videoSrc);
                $("#modal").addClass("opened");
                $("body")
                    .addClass("fixed")
                    .css({
                        top: -scrollPosition - 72,
                    });
                $("#modal .video").get(0).load();
                $("#modal .video").get(0).play();
            });

            $("#modal .close, #modal").on("click", function (e) {
                e.preventDefault();
                if (e.target !== this) return;
                $("#modal").removeClass("opened");
                $("body").removeClass("fixed");
                $("#modal .video").get(0).pause();
                $("#modal .video").get(0).currentTime = 0;
                window.scrollTo(0, scrollPosition);
            });

            document.body.addEventListener("keyup", (ev) => {
                if (ev.key === "Escape") {
                    $("#modal, #ask-assistant").removeClass("opened");
                    $("body").removeClass("fixed");
                    $("#modal .video").get(0).pause();
                    $("#modal .video").get(0).currentTime = 0;
                }
            });

            // ask assistant

            $("a.open-popup").on("click", function (e) {
                e.preventDefault();
                scrollPosition = window.pageYOffset;
                $("#ask-assistant").addClass("opened");
                $("body")
                    .addClass("fixed")
                    .css({
                        top: -scrollPosition - 72,
                    });
                $(".grecaptcha-badge").css("opacity", "1");
            });

            $("#ask-assistant .close").on("click", function (e) {
                e.preventDefault();
                if (e.target !== this) return;
                $("#ask-assistant").removeClass("opened");
                $("body").removeClass("fixed");
                window.scrollTo(0, scrollPosition);
                $(".grecaptcha-badge").css("opacity", "0");
            });
        },

        ajaxTherapists: function () {
            let currentPage = 1;
            var displayedItems = 4;
            var debounceTimeout;

            var getSelectedCheckboxes = function (name) {
                var selected = [];
                $('input[name="' + name + '[]"]:checked').each(function () {
                    selected.push($(this).val());
                });
                return selected;
            };

            $("#load-more").on("click", function (e) {
                e.preventDefault();
                var loadMoreButton = $(this);
                var grid = $(this).closest(".container").find(".therapists-grid");
                var specs = getSelectedCheckboxes("specializations");
                var issues = getSelectedCheckboxes("problems");
                var key = $("#my-search").val();
                currentPage++;

                $.ajax({
                    url: ajaxurl,
                    type: "POST",
                    data: {
                        action: "load_more",
                        displayedItems: displayedItems,
                        specs: specs,
                        issues: issues,
                        key: key,
                        postIds: postIds,
                    },
                    beforeSend: function () {
                        loadMoreButton.text("Ładuję...");
                    },
                    success: function (response) {
                        if (response) {
                            grid.append(response);
                            displayedItems = parseInt(displayedItems) + 4;
                            loadMoreButton.text("Zobacz więcej Terapeutów");

                            $("html, body").animate(
                                {
                                    scrollTop:
                                        $(
                                            ".therapists-grid .grid-item:nth-child(" + (displayedItems - 2) + ")"
                                        ).offset().top - 100,
                                },
                                800
                            );

                            if (pages - currentPage <= 0) {
                                loadMoreButton.addClass("hidden");
                            }
                        }
                    },
                });
            });

            var filterTherapists = function () {
                var loadMoreButton = $("#load-more");
                var grid = $(".therapists-grid");
                var specs = getSelectedCheckboxes("specializations");
                var issues = getSelectedCheckboxes("problems");
                var key = $("#my-search").val();
                displayedItems = 4;

                $.ajax({
                    url: ajaxurl,
                    type: "POST",
                    data: {
                        action: "filter_therapists",
                        displayedItems: displayedItems,
                        specs: specs,
                        issues: issues,
                        key: key,
                    },
                    success: function (response) {
                        grid.html(response);

                        if (pages <= 1) {
                            loadMoreButton.addClass("hidden");
                        } else {
                            loadMoreButton.removeClass("hidden");
                        }
                    },
                });
            };

            $("#my-search").on("input", function () {
                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(function () {
                    filterTherapists();
                }, 300);
            });

            $("#therapists .filters input[type='checkbox']").on("change", function () {
                filterTherapists();

                if ($(this).is(":checked")) {
                    $(this).closest(".blurb").addClass("active");
                } else {
                    $(this).closest(".blurb").removeClass("active");
                }

                var box = $(this).parent().parent();

                var count = box.children(".active").length;
                console.log(count);
                if (count == 0) {
                    $(box).parent().find(".count").hide();
                } else {
                    $(box).parent().find(".count").show();
                    $(box).parent().find(".count").html(count);
                }
            });

            $(document).on("click", "a.btn-reset", function (e) {
                e.preventDefault();
                var group = $(this).parent().parent();
                group.find('input[type="checkbox"]').each(function () {
                    $(this).prop("checked", false);
                    $(this).parent().removeClass("active");
                    $(this).parent().parent().parent().find(".count").hide();
                });
                filterTherapists();
            });

            $(document).on("click", "a.btn-close", function (e) {
                e.preventDefault();
                $(this).parent().parent().removeClass("opened");
            });

            $(document).on("click", ".reset", function (e) {
                e.preventDefault();
                $("#therapists .filters input[type='checkbox']").each(function () {
                    $(this).prop("checked", false);
                    $(this).parent().removeClass("active");
                    $("#therapists .count").hide();
                });
                $("#my-search").val("");
                filterTherapists();
            });

            $(document).on("click", function (e) {
                if (!$(e.target).closest("#therapists .tax-filter").length) {
                    $("#therapists .checkbox-group").removeClass("opened");
                }
            });

            $("#therapists .tax-filter .tax-title").on("click", function () {
                //$("#therapists .checkbox-group").removeClass("opened");
                $(this).parent().siblings(".tax-filter").find(".checkbox-group").removeClass("opened");
                $(this).next().toggleClass("opened");
            });

            document.body.addEventListener("keyup", (ev) => {
                if (ev.key === "Escape") {
                    $("#therapists .checkbox-group").removeClass("opened");
                }
            });

            $(".search-wrap .icon, .search-wrap .close").on("click", function () {
                $(this).parent().toggleClass("opened");
            });
        },

        ameliaOrder: function () {
            $(document).ready(function () {
                var productDescription = $(
                    ".woocommerce-table__product-name.product-name, #order_review td.product-name"
                );

                if (productDescription.length > 0) {
                    var descriptionContents = productDescription.contents();
                    for (var i = 0; i < descriptionContents.length; i++) {
                        if (
                            descriptionContents[i].nodeName === "BR" &&
                            descriptionContents[i + 1] &&
                            descriptionContents[i + 1].nodeName === "BR"
                        ) {
                            $(descriptionContents[i]).remove();
                        }
                    }
                }
            });

            $(document).ready(function () {
                var productDescription = $(
                    ".woocommerce-table__product-name.product-name, #order_review td.product-name"
                );

                if (productDescription.length > 0) {
                    var descriptionContents = productDescription.contents();

                    var foundHR = false;

                    for (var i = 0; i < descriptionContents.length; i++) {
                        if (descriptionContents[i].nodeName === "HR") {
                            foundHR = true;
                            $(descriptionContents[i]).remove();
                        } else if (foundHR) {
                            if (descriptionContents[i].nodeName === "BR") {
                                $(descriptionContents[i]).remove();
                                break;
                            }
                        } else {
                            $(descriptionContents[i]).remove();
                        }
                    }
                }
            });
        },

        favorites: function () {
            $(".add-to-favorites").on("click", function (e) {
                e.preventDefault();
                var therapistId = $(this).data("therapist-id");
                var isFavoriteItem = $(this).hasClass("favorited");
                var favoritePage = $("body").hasClass("page-template-page-favorites");

                if (isFavoriteItem) {
                    removeFromFavorites(therapistId);
                    $(this).text("Dodaj do ulubionych");
                    if (favoritePage) {
                        $(this).closest(".grid-item").fadeOut(400).remove();
                    }
                } else {
                    addToFavorites(therapistId);
                    $(this).text("Usuń z ulubionych");
                }
            });

            function addToFavorites(therapistId) {
                var data = {
                    action: "add_to_favorites",
                    therapist_id: therapistId,
                };

                $.ajax({
                    url: ajaxurl,
                    type: "POST",
                    data: data,
                    success: function (response) {
                        $('.add-to-favorites[data-therapist-id="' + therapistId + '"]').addClass("favorited");
                    },
                });
            }

            function removeFromFavorites(therapistId) {
                var data = {
                    action: "remove_from_favorites",
                    therapist_id: therapistId,
                };

                $.ajax({
                    url: ajaxurl,
                    type: "POST",
                    data: data,
                    success: function (response) {
                        $('.add-to-favorites[data-therapist-id="' + therapistId + '"]').removeClass("favorited");
                    },
                });
            }
        },

        form: function () {
            $('input[name="therapy_type"]').change(function () {
                if (this.value === "terapia-indywidualna") {
                    $("#age_field").show();
                    $('input[name="age"]').prop("required", true);
                    if ($('input[name="age"]:checked').val() === "nastolatek") {
                        $("#teenager_age_group_field").show();
                        $('input[name="teenager_age_group"]').prop("required", true);
                    } else {
                        $("#teenager_age_group_field").hide();
                        $('input[name="teenager_age_group"]').prop("required", false);
                    }
                } else {
                    $("#age_field").hide();
                    $('input[name="age"]').prop("required", false);
                    $('input[name="teenager_age_group"]').prop("required", false);
                    $("#teenager_age_group_field").hide();
                }
            });

            $('input[name="age"]').change(function () {
                if (
                    $('input[name="therapy_type"]:checked').val() === "terapia-indywidualna" &&
                    this.value === "nastolatek"
                ) {
                    $(".step.last").hide();
                    $("#teenager_age_group_field").show();
                    $('input[name="teenager_age_group"]').prop("required", true);
                } else {
                    $("#teenager_age_group_field").hide();
                    $('input[name="teenager_age_group"]').prop("required", false);
                }
            });
            $('input[name="therapist_gender"]').change(function () {
                $("#therapists-form a.btn").hide();
                $('#therapists-form input[type="submit"]').show();
            });

            $('input[type="radio"]').change(function (evt) {
                var trg = $(evt.target),
                    trg_par = trg.parent();

                if (trg.attr("type") === "radio" && trg_par && trg_par.prop("tagName").toLowerCase() === "label") {
                    var prior = $("form").find('label.checked input[name="' + trg.attr("name") + '"]');

                    if (prior.length) {
                        prior.parent().removeClass("checked");
                    }

                    trg_par.addClass("checked");
                }
            });

            $('input[type="radio"]:not(#individual):not(#teenager)').change(function () {
                $(".step.last").show();
            });
            $("#individual,#teenager ").change(function () {
                $(".step.last").hide();
            });

            $("#therapists-form").on("submit", function (event) {
                var formData = $(this).serialize();

                $.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: {
                        action: "load_form_therapists",
                        formData: formData,
                    },
                    success: function (response) {
                        var $responseHtml = $(response);
                        console.log($responseHtml.find(".therapists-grid .grid-item").length);

                        if ($responseHtml.find(".grid-item").length > 0) {
                            $("#choose-therapists .container").html(response);
                            $(".page-intro h1").text("Wybrani Terapeuci");
                            $(".page-intro h2.smaller").text(
                                "Na podstawie Twoich odpowiedzi wybraliśmy dla Ciebie następujących terapeutów:"
                            );
                        } else {
                            $.ajax({
                                type: "POST",
                                url: ajaxurl,
                                data: {
                                    action: "get_all_therapists",
                                },
                                success: function (allTherapistsHtml) {
                                    $("#choose-therapists .container").html(allTherapistsHtml);
                                    $(".page-intro h1").text("Niestety nie znaleźliśmy pasujących Terapeutów");
                                    $(".page-intro h2.smaller").text("Oto wszyscy dostępni terapeuci:");
                                },
                            });
                        }
                    },
                });
                return false;
            });
        },

        testimonials: function () {
            const apiKey = "N+yofcJYXvj3ah5Ycz3d3O/ZL1A67L5dtgkBzF7xUV2t";

            function getTestimonialMeta(paramName) {
                var urlParams = new URLSearchParams(window.location.search);
                return urlParams.get(paramName);
            }

            var therapistId = parseInt(getTestimonialMeta("therapist_id"));
            var customerId = parseInt(getTestimonialMeta("customer_id"));
            var appointmentId = parseInt(getTestimonialMeta("appointment"));

            function fetchData(url, successCallback) {
                $.ajax({
                    url: url,
                    type: "GET",
                    dataType: "json",
                    headers: {
                        Amelia: apiKey,
                        "Content-Type": "application/json",
                    },
                    success: successCallback,
                    error: function (xhr, status, error) {
                        console.error("Wystąpił błąd podczas pobierania danych:", error);
                    },
                });
            }

            if (!isNaN(therapistId)) {
                fetchData(
                    `/wp-admin/admin-ajax.php?action=wpamelia_api&call=/api/v1/users/providers/${therapistId}`,
                    function (response) {
                        $("#therapist_id").val(response.data.user.externalId);
                        $("#therapist-name").text(response.data.user.firstName + " " + response.data.user.lastName);
                    }
                );
            }

            if (!isNaN(customerId)) {
                fetchData(
                    `/wp-admin/admin-ajax.php?action=wpamelia_api&call=/api/v1/users/customers/${customerId}`,
                    function (response) {
                        $("#customer_id").val(response.data.user.externalId);
                        $("#name").text(response.data.user.firstName);
                        $("#first_name").val(response.data.user.firstName);
                        $("#last_name").val(response.data.user.lastName);
                    }
                );
            }

            if (!isNaN(appointmentId)) {
                fetchData(
                    `/wp-admin/admin-ajax.php?action=wpamelia_api&call=/api/v1/appointments/${appointmentId}`,
                    function (response) {
                        var date = new Date(response.data.appointment.bookingStart);

                        var dateFormatter = new Intl.DateTimeFormat("pl-PL", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        });
                        var timeFormatter = new Intl.DateTimeFormat("pl-PL", {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: false,
                        });
                        var formattedDate = dateFormatter.format(date);
                        var formattedTime = timeFormatter.format(date);

                        var formattedDateTime = `${formattedDate}, godz. ${formattedTime}`;

                        $("#date").text(formattedDateTime);
                        $("#appointment_date").val(formattedDateTime);
                    }
                );
            }

            if ($("#manual_therapist_id").length) {
                $("#testimonial-form form input[type=submit]").prop("disabled", true);
                fetchData(
                    "/wp-admin/admin-ajax.php?action=wpamelia_api&call=/api/v1/users/providers",
                    function (response) {
                        if (response.data && response.data.users) {
                            var users = response.data.users;
                            var select = $("#manual_therapist_id");
                            users.forEach(function (user) {
                                if (user.status === "visible") {
                                    var option = $("<option></option>")
                                        .val(user.externalId)
                                        .text(user.firstName + " " + user.lastName);
                                    select.append(option);
                                }
                            });
                            console.log("users loaded");
                            $("#testimonial-form form input[type=submit]").prop("disabled", false);
                        }
                    }
                );

                $(document).on("change", "#manual_therapist_id", function () {
                    var selectedUserId = $(this).val();
                    console.log("elo");
                    fetchData(
                        "/wp-admin/admin-ajax.php?action=wpamelia_api&call=/api/v1/users/providers",
                        function (response) {
                            var users = response.data.users;
                            console.log(users);
                            for (var i = 0; i < users.length; i++) {
                                if (users[i].externalId == selectedUserId) {
                                    $("#amelia_id").val(users[i].id);
                                    break;
                                }
                            }
                        }
                    );
                });
            }
        },
    };
})(jQuery);
